import { isDefined } from '@sgme/fp';
import type { MakeRequired } from 'types/utils';

export function isPropertiesDefined<T extends object, Keys extends keyof T>(
  obj: T,
  ...properties: Keys[]
): obj is MakeRequired<T, Keys> {
  return properties.every(property => isDefined(obj[property]));
}
